import { TYPES } from '@/engine/ioc';
import styled from 'styled-components';

import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';

import type { FC } from 'react';
import type { ViewsService } from '@/engine/app/Views.service';
import type { IPhasesCurveController } from '@/components/phasesCurve/interfaces';

export const SideHeader: FC = observer(() => {
  const viewsService = useInjection<ViewsService>(TYPES.ViewsService);
  const controller = useInjection<IPhasesCurveController>(TYPES.IPhasesCurveController);

  const phasesLength = controller.getPhasesLength();
  const currentPhasePercentage = controller.currentPhasePercentage;
  const hasPhase = currentPhasePercentage !== undefined;

  const isStandardLabel = phasesLength !== 1 || !hasPhase;

  return (
    <Container>
      <Label $isStandardLabel={isStandardLabel}>{viewsService.currentViewOrThrow.getSideLabel()}</Label>
      {hasPhase && phasesLength === 1 && <PhaseContainer>Phase: {currentPhasePercentage}%</PhaseContainer>}
    </Container>
  );
});

const Container = styled.div`
  overflow: auto;
  grid-area: sideheader;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PhaseContainer = styled.div`
  margin: 0 1.2em;
`;

const Label = styled.h2<{ $isStandardLabel: boolean }>`
  color: ${({ theme }): string => theme.font};
  font-size: ${({ $isStandardLabel }): string => ($isStandardLabel ? '1.5rem' : '1.15rem')};
  font-weight: normal;
  margin-left: 0.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (width < 100rem) {
    font-size: ${({ $isStandardLabel }): string => ($isStandardLabel ? '1.4rem' : '1rem')};
  }
`;
